import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  props: {
  comment: {
    type: String,
    required: true,
    default: 'No comments so far'
  }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", null, _toDisplayString(props.comment), 1))
}
}

})